import { useEffect, useState } from 'react';
import { fetchMyAchievements, type MyAchievementsResponse } from './achievementsApi';
import { HopperIcon } from '../ui/icons/HopperIcon';

export function AchievementsSummaryCard() {
  const [data, setData] = useState<MyAchievementsResponse | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchMyAchievements().then((response) => { if (!cancelled) setData(response); }).catch(() => { if (!cancelled) setData(null); });
    return () => { cancelled = true; };
  }, []);

  if (!data) return null;

  const nearest = data.families
    .filter((family) => family.next_tier !== null)
    .slice()
    .sort((a, b) => b.progress_percent - a.progress_percent)[0] ?? null;

  return (
    <section className="profile-reference-card achievement-profile-summary">
      <button type="button" onClick={() => window.location.assign('/profile/achievements')}>
        <span className="achievement-profile-summary__icon"><HopperIcon name="trophy" size={22} /></span>
        <span className="achievement-profile-summary__copy">
          <strong>Достижения</strong>
          <small>Открыто {data.summary.total_unlocked_tiers} из {data.summary.total_visible_tiers} ступеней</small>
          {nearest?.next_tier && <em>Ближе всего: {nearest.family_name} · {nearest.next_tier.name} · {nearest.progress_percent}%</em>}
        </span>
        <HopperIcon name="chevron-right" size={18} />
      </button>
    </section>
  );
}
